import { render, staticRenderFns } from "./SettingsSteps.vue?vue&type=template&id=a3a0a5f8&scoped=true"
import script from "./SettingsSteps.vue?vue&type=script&lang=js"
export * from "./SettingsSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a0a5f8",
  null
  
)

export default component.exports